module.exports = __webpack_public_path__ + "static/media/Filosofia.eb8f87cd.pdf";